import { z } from 'zod'
import {
  SimpleBoxOptions,
  ProgressBoxOptions,
  PeriodContainerOptions,
  ContainerOptions,
  MetricFilterContainerOptions,
  KpiListOptions,
  WaterfallChartOptions,
  LineChartOptions,
  KpiTabsContainerOptions,
  PeriodTableOptions,
  BarChartOptions,
} from './schemas'
import { SimpleBoxRegistry } from './components/SimpleBox'
import { ProgressBoxRegistry } from './components/ProgressBox'
import { PeriodContainerRegistry } from './components/PeriodContainer'
import { ContainerRegistry } from './components/Container'
import { MetricFilterContainerRegistry } from './components/MetricFilterContainer'
import { KpiListRegistry } from './components/KpiList'
import { WaterfallChartRegistry } from './components/WaterfallChart'
import { LineChartRegistry } from './components/LineChart'
import { KpiTabsContainerRegistry } from './components/KpiTabsContainer'
import { PeriodTableRegistry } from './components/PeriodTable'

const createWidgetSchema = <T extends string>(
  widget: T,
  options: z.ZodTypeAny
) =>
  z.object({
    widget: z.literal(widget),
    id: z.string(),
    options,
    children: z.array(z.string()),
  })

export const WidgetZod = z.discriminatedUnion('widget', [
  createWidgetSchema('SimpleBox', SimpleBoxOptions),
  createWidgetSchema('ProgressBox', ProgressBoxOptions),
  createWidgetSchema('Container', ContainerOptions),
  createWidgetSchema('PeriodContainer', PeriodContainerOptions),
  createWidgetSchema('MetricFilterContainer', MetricFilterContainerOptions),
  createWidgetSchema('KpiList', KpiListOptions),
  createWidgetSchema('WaterfallChart', WaterfallChartOptions),
  createWidgetSchema('BarChart', BarChartOptions),
  createWidgetSchema('LineChart', LineChartOptions),
  createWidgetSchema('KpiTabsContainer', KpiTabsContainerOptions),
  createWidgetSchema('PeriodTable', PeriodTableOptions),
])

export type Widgets = z.infer<typeof WidgetZod>

type RegistryEntry = {
  component: React.ComponentType<{ id: string }>
  formComponent: React.ComponentType<{ id: string }>
  mock: React.ComponentType
  getInitialOptions: () => unknown
}

export function registry(key: string): RegistryEntry | undefined {
  return {
    SimpleBox: SimpleBoxRegistry,
    ProgressBox: ProgressBoxRegistry,
    Container: ContainerRegistry,
    PeriodContainer: PeriodContainerRegistry,
    MetricFilterContainer: MetricFilterContainerRegistry,
    KpiList: KpiListRegistry,
    WaterfallChart: WaterfallChartRegistry,
    LineChart: LineChartRegistry,
    KpiTabsContainer: KpiTabsContainerRegistry,
    PeriodTable: PeriodTableRegistry,
  }[key]
}
